const prod = {
    url: {
        API_URL: 'https://easydividend.nexdigm.com/Shareholders',
        Web_URL: 'https://easydividend.nexdigm.com/Shareholders',
        EnvType: "PROD"

    }
};

const preprod = {
    url: {
        API_URL: 'https://uatapp.nexdigm.com/intranet/PreProd/EasyDividendShareholderPortal/UI',
        Web_URL: 'https://uatapp.nexdigm.com/intranet/PreProd/EasyDividendShareholderPortal/UI',
        EnvType: "PREPROD"

    }
};

const qa = {
    url: {
        API_URL: 'https://devapp.nexdigm.com/intranet/QA/EasyDividendShareholderPortal/UI',
        Web_URL: 'https://devapp.nexdigm.com/intranet/QA/EasyDividendShareholderPortal/UI',
        EnvType: "QA"

    }
};

const uat = {
    url: {
        API_URL: 'https://uatapp.nexdigm.com/intranet/UAT/EasyDividendShareholderPortal/UI',
        Web_URL: 'https://uatapp.nexdigm.com/intranet/UAT/EasyDividendShareholderPortal/UI',
        EnvType: "UAT"

    }
};

const dev = {
    url: {
        API_URL: 'https://devapp.nexdigm.com/intranet/Dev/EasyDividendShareholderPortal/UI',
        Web_URL: 'https://devapp.nexdigm.com/intranet/Dev/EasyDividendShareholderPortal/UI',
        EnvType: "DEV"

    }
};

const local = {
    url: {
        API_URL: 'https://localhost:5002',
        Web_URL: 'https://localhost:5002',
        EnvType: "LOCAL"
    }
};

export const config = prod;


//const getEnvironmentConfig = () => {
//    const storedConfig = localStorage.getItem('appConfig');

//    if (storedConfig) {
//        return JSON.parse(storedConfig); // Return the stored config if available
//    }

//    const { hostname } = window.location;
//    const baseUrl = window.location.origin;
//    const pathname = window.location.pathname.endsWith('/')
//        ? window.location.pathname.slice(0, -1)
//        : window.location.pathname;

//    const configMap = {
//        'debentureshub.nexdigm.com': {
//            url: {
//                API_URL: baseUrl,
//                Web_URL: baseUrl,
//                EnvType: "PROD",
//            }
//        },
//        'uatapp.nexdigm.com': {
//            url: {
//                API_URL: `${baseUrl}${pathname}`,
//                Web_URL: `${baseUrl}${pathname}`,
//                EnvType: "UAT",
//            }
//        },
//        'devapp.nexdigm.com': {
//            url: {
//                API_URL: `${baseUrl}${pathname}`,
//                Web_URL: `${baseUrl}${pathname}`,
//                EnvType: "UAT",
//            }
//        },
//        'localhost': {
//            url: {
//                API_URL: `${baseUrl}${pathname}`,
//                Web_URL: `${baseUrl}${pathname}`,
//                EnvType: "DEV",
//            }
//        },
//    };

//    const config = configMap[hostname];

//    if (!config) {
//        throw new Error('Unknown environment');
//    }

//    localStorage.setItem('appConfig', JSON.stringify(config)); // Store in local storage
//    return config; // Return the new config
//};

//// Load the config once and export it
//export const config = getEnvironmentConfig();






